var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8666 8.66699V21.0388C15.8666 21.1705 15.8991 21.3002 15.9612 21.4163C16.0234 21.5324 16.1132 21.6314 16.2228 21.7045L17.322 22.4373C17.4287 22.5084 17.5509 22.5528 17.6783 22.5669C17.8058 22.5809 17.9347 22.5641 18.0543 22.5178C18.1738 22.4716 18.2806 22.3973 18.3654 22.3012C18.4503 22.2051 18.5108 22.0901 18.5419 21.9657L19.8666 16.667",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8666 16.6666C20.9274 16.6666 21.9449 16.2452 22.695 15.4951C23.4452 14.7449 23.8666 13.7275 23.8666 12.6666C23.8666 11.6058 23.4452 10.5884 22.695 9.83822C21.9449 9.08808 20.9274 8.66665 19.8666 8.66665H15.8666C15.8666 8.66665 10.4214 8.66665 5.18147 4.27189C5.06493 4.1738 4.92281 4.11103 4.77182 4.09096C4.62083 4.07089 4.46724 4.09435 4.32913 4.15858C4.19101 4.22282 4.07411 4.32515 3.99217 4.45355C3.91023 4.58196 3.86666 4.73109 3.86658 4.88341V20.4499C3.86666 20.6022 3.91023 20.7513 3.99217 20.8797C4.07411 21.0081 4.19101 21.1105 4.32913 21.1747C4.46724 21.239 4.62083 21.2624 4.77182 21.2423C4.92281 21.2223 5.06493 21.1595 5.18147 21.0614C10.4214 16.6666 15.8666 16.6666 15.8666 16.6666H19.8666Z",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/Megaphone.195a33b1c77aa669d8dc99b499f5ed05.svg";
export { ForwardRef as ReactComponent };